<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-12">
        <fullscreen
          background="#F3F5F7"
          class="table-fullscreen"
          ref="fullscreen"
          @change="fullScreenChange"
        >
          <div class="page-table-header">
            <PageHeader :page-title="'Balances'">
              <template v-slot:buttons>
                <b-button
                  variant="success"
                  v-if="$can(permissions.CreateFinancesInvoices)"
                  type="button"
                  class="button"
                  @click.prevent="showCreateModal"
                  :disabled="isDataPageLoading"
                >
                  Create
                </b-button>
              </template>
            </PageHeader>
            <div class="d-flex justify-content-end">
              <b-button
                class="button btn-icon mr-1"
                variant="outline-info"
                @click="toggleFullscreen"
              >
                <span class="material-icons">
                  fullscreen_exit
                </span>
              </b-button>
            </div>
            <div class="row mb-4">
              <div class="col">
                <div class="editor-container">
                  <TextEditor
                    :in-modal="false"
                    data-already-loaded
                    :entity-type="commentEntityTypes.ReportsBalancesPage"
                    :entity-id="0"
                  />
                </div>
              </div>
            </div>
            <TableForPage
              ref="table"
              class="balances-table"
              :tableData="getBalancesTableData"
              :fields="getTableField"
              :slots="getSlots"
              :isEdit="$can(permissions.UpdateAllFinancesInvoices)"
              :isRemove="$can(permissions.DeleteFinancesInvoices)"
              :thead-top="true"
              :cell-fixed="false"
              @edit="editBalanceItem"
              @remove="removeBalanceItem"
            >
              <template v-slot:thead="data">
                <b-tr>
                  <b-th colspan="6"></b-th>
                  <b-th class="text-center col-border" :colspan="getNDetails.length">Dmytro Navozenko</b-th>
                  <b-th class="text-center col-border" :colspan="getPDetails.length">Ievgen Prystupa</b-th>
                  <b-th></b-th>
                </b-tr>
              </template>
              <template v-slot:balance_date="data">
                {{ getDate(data.item.balance_date) }}
              </template>
              <template v-for="slot in ownBankDetailsSlots" v-slot:[`head(${slot.name})`]="data">
                <div
                :key="slot.name"
                v-b-tooltip.hover="{ variant: 'base' }"
                :title="data.field.tooltip"
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:comment="data">
                <div
                class="text-comment"
                v-b-tooltip.hover="{ variant: 'base' }"
                :title="data.item.comment"
                >
                  {{ data.item.comment }}
                  <TextEditor
                    class="position-absolute editor-block"
                    :in-modal="true"
                    data-already-loaded
                    :entity-type="commentEntityTypes.ReportsBalancesItem"
                    :entity-id="data.item.balance_date"
                    @saveText="saveBalanceItem"
                  />
                </div>
              </template>
            </TableForPage>
          </div>
        </fullscreen>
      </div>
    </div>

    <FinanceBalancesModal
      v-model="createModal.show"
      mode="create"
      :form-data="createModal.form"
      :title="createModal.title"
      :submitButtonText="createModal.submitButtonText"
      @submit="createFinanceBalance"
    />
    <FinanceBalancesModal
      v-model="editModal.show"
      mode="edit"
      :form-data="editModal.form"
      :title="editModal.title"
      :submitButtonText="editModal.submitButtonText"
      @submit="editFinanceBalance"
    />
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import { commentEntityTypes } from '@mocks/comment-entity-types'
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import FinanceMixin from '@/mixins/FinanceMixin'
import PageHeader from '@components/PageHeader'
import FinanceBalancesModal from '@components/modals/FinanceBalancesModal'
import TextEditor from '@components/TextEditor'
import TableForPage from '@tables/TableForPage'
import Moment from 'moment'

export default {
  name: 'FinanceReportsBalances',
  components: {
    PageHeader,
    TableForPage,
    FinanceBalancesModal,
    TextEditor
  },
  mixins: [FinanceMixin],
  data () {
    const defaultForm = {
      fields: {
        'balance_date': {
          type: 'datepicker',
          name: 'balance_date',
          label: 'Balance Date',
          format: 'yyyy-MM-dd',
          placeholder: 'Balance Date',
          class: 'col-12',
          value: Moment().format('YYYY-MM-DD')
        }
      }
    }
    return {
      permissions,
      defaultForm,
      modalTitle: 'balance',
      fullscreen: false,
      ownBankDetailsSlots: {},
      tableMock: [
        {
          balance_date: '2022-06-24',
          change: 8407.50,
          total: 76104.98,
          total_own_banks: {
            dmytro_navozenko: 30118.19,
            ievgen_prystupa: 45986.79
          },
          own_bank_details: [
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD UKRSIBBANK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD UKRSIBBANK',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'EUR UKRSIBBANK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'UAH UKRSIBBANK',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD PAYONEER',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD UPWORK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD PAYONEER',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD own card / cash',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            }
          ],
          comment: 'Инвестировали в SEO $5000 Инвестировали в SEO $5000 Инвестировали в SEO $5000'
        },
        {
          balance_date: '2022-06-02',
          change: -463.88,
          total: 67697.48,
          total_own_banks: {
            dmytro_navozenko: 26209.68,
            ievgen_prystupa: 41487.80
          },
          own_bank_details: [
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD UKRSIBBANK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD UKRSIBBANK',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'EUR UKRSIBBANK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'UAH UKRSIBBANK',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD PAYONEER',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD UPWORK',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Ievgen Prystupa',
              owner_id: 2,
              bank_name: 'USD PAYONEER',
              value: 71,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
            },
            {
              owner: 'Dmytro Navozenko',
              owner_id: 1,
              bank_name: 'USD own card / cash',
              value: 7400,
              summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
            }
          ],
          comment: 'Инвестировали в SEO $5000'
        }
      ]
    }
  },
  computed: {
    ...mapActions({
      fetchComments: 'comments/fetchComments'
    }),
    getOwnBankDetails () {
      const tableData = this.getBalancesTableData.slice()
      for (const i in tableData) {
        tableData[i].own_bank_details
          .sort((a, b) => {
            return a.owner_id - b.owner_id
          })
        tableData[i]._cellVariants = {
          change: tableData[i].change < 0 ? 'danger' : 'success'
        }
      }
      const ownBankDetailsArr = tableData[0].own_bank_details

      return ownBankDetailsArr
    },
    getSlots () {
      this.setOwnBankDetailsSlots()
      return {
        balance_date: {
          name: 'balance_date'
        },
        ...this.ownBankDetailsSlots,
        comment: {
          name: 'comment'
        },
        controls: {
          name: 'controls'
        }
      }
    },
    getTableField () {
      const bankDetails = this.getOwnBankDetails.slice()
      const ownBankDetailsFields = bankDetails.map((item, i) => {
        return {
          key: `own_bank_details[${i}].value`,
          label: item.bank_name,
          tooltip: item.summary,
          class: 'column-bank-details text-center col-border'
        }
      })

      return [
        {
          key: 'actions',
          label: '',
          class: 'column-more'
        },
        {
          key: 'balance_date',
          label: 'date',
          class: 'column-fix-w column-date col-border text-center'
        },
        {
          key: 'change',
          label: 'change $',
          class: 'column-fix-w text-center col-border text-center'
        },
        {
          key: 'total',
          label: 'total $',
          class: 'column-fix-w text-center col-border text-center'
        },
        {
          key: 'total_own_banks.dmytro_navozenko',
          label: 'Dmytro Navozenko total $',
          class: 'column-bank-details text-center col-border'
        },
        {
          key: 'total_own_banks.ievgen_prystupa',
          label: 'Ievgen Prystupa total $',
          class: 'column-bank-details text-center col-border'
        },
        ...ownBankDetailsFields,
        {
          key: 'comment',
          label: 'comments',
          class: 'column-comment text-center'

        }
      ]
    },
    getBalancesTableData () {
      const todayData = this.getTodayBalance()
      const tableData = [todayData, ...this.tableMock]
      return tableData || []
    },
    getNDetails () {
      const ownBankDetails = this.getBalancesTableData[0].own_bank_details.slice()
      return ownBankDetails.filter(item => item.owner === 'Dmytro Navozenko')
    },
    getPDetails () {
      const ownBankDetails = this.getBalancesTableData[0].own_bank_details.slice()
      return ownBankDetails.filter(item => item.owner === 'Ievgen Prystupa')
    },
    commentEntityTypes () {
      return commentEntityTypes
    }
  },
  mounted () {
    this.fetchComments({ type: commentEntityTypes.ReportsBalancesPage })
    this.fetchComments({ type: commentEntityTypes.ReportsBalancesItem })
  },
  methods: {
    createFinanceBalance () {

    },
    editFinanceBalance () {

    },
    getTodayBalance () {
      return {
        balance_date: 'Today',
        change: 8407.50,
        total: 76104.98,
        total_own_banks: {
          dmytro_navozenko: 30118.19,
          ievgen_prystupa: 45986.79
        },
        own_bank_details: [
          {
            owner: 'Ievgen Prystupa',
            owner_id: 2,
            bank_name: 'USD UKRSIBBANK',
            value: 71,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
          },
          {
            owner: 'Dmytro Navozenko',
            owner_id: 1,
            bank_name: 'USD UKRSIBBANK',
            value: 7400,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
          },
          {
            owner: 'Ievgen Prystupa',
            owner_id: 2,
            bank_name: 'EUR UKRSIBBANK',
            value: 71,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
          },
          {
            owner: 'Dmytro Navozenko',
            owner_id: 1,
            bank_name: 'UAH UKRSIBBANK',
            value: 7400,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
          },
          {
            owner: 'Dmytro Navozenko',
            owner_id: 1,
            bank_name: 'USD PAYONEER',
            value: 7400,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
          },
          {
            owner: 'Ievgen Prystupa',
            owner_id: 2,
            bank_name: 'USD UPWORK',
            value: 71,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
          },
          {
            owner: 'Ievgen Prystupa',
            owner_id: 2,
            bank_name: 'USD PAYONEER',
            value: 71,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Ievgen Prystupa)'
          },
          {
            owner: 'Dmytro Navozenko',
            owner_id: 1,
            bank_name: 'USD own card / cash',
            value: 7400,
            summary: 'USD 111111111111111111111 (UKRSIBBANK Dmytro Navozenko)'
          }
        ],
        comment: ''
      }
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    toggleFullscreen () {
      this.$refs['fullscreen'].toggle()
    },
    getDate (date) {
      if (date.split('-').length === 1) {
        return date
      }
      return this._toLocalTime(date, 'YYYY-MM-DD') || ''
    },
    setOwnBankDetailsSlots () {
      const bankDetails = this.getOwnBankDetails.slice()
      this.ownBankDetailsSlots = {}
      bankDetails.forEach((item, i) => {
        const slot = {
          type: 'head',
          name: `own_bank_details[${i}].value`
        }
        this.ownBankDetailsSlots[`own_bank_details[${i}]`] = slot
      })
    },
    editBalanceItem (data) {
      this.editModal.form = cloneDeep(this.defaultForm)
      this.editModal.form.fields.balance_date.value = data.balance_date

      this.editModal.show = true
    },
    async removeBalanceItem (data) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the balance item?'
      )

      if (!confirm) return

      const indexItem = this.tableMock.findIndex(item => item.balance_date === data.balance_date)
      if (indexItem !== -1) {
        this.tableMock.splice(indexItem, 1)
      }
    },
    saveBalanceItem (saveData) {
      const currentIndex = this.tableMock.findIndex(item => item.balance_date === saveData.item)
      if (currentIndex !== -1) {
        this.tableMock[currentIndex].comment = saveData.data
      }
    }
  }
}
</script>

<style lang="scss">
  .table__theme-default.balances-table {
    tbody {
      tr:first-child {
        font-weight: 700;
        .column-more,
        .column-comment {
          opacity: 0;
        }
      }
    }
    .column {
      &-fix-w {
        width: 100px;
      }
      &-date {
        white-space: nowrap;
      }
      &-bank-details {
        min-width: 75px;
      }
      &-comment {
        width: 250px;
        max-width: 250px;
      }
      &-more {
        width: 30px;

        .navbar__dropdown {
          margin-left: 0;
        }
      }
    }
    .col-border {
      border-right: 1px solid #E4E7EE;
      border-left: 1px solid #E4E7EE;
    }
    .text-comment {
      max-height: 20px;
      overflow: hidden;
      max-width: 220px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .editor-block {
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
  }

</style>
